import { InjectionToken } from '@angular/core';
import { ILoadingPhrases } from './interfaces';
export const DEFAULT_LOADING_PHRASES = new InjectionToken<ILoadingPhrases>(
  'DEFAULT_LOADING_PHRASES'
);
